<ng-container *transloco="let t; read: 'ttl-editor'">
  <form *ngIf="orgData !== undefined" [formGroup]="form">
    <div class="form-row">
      <div class="col">
        <span class="inputfield w-full">
          <input
            id="expireAt"
            pInputText
            type="datetime-local"
            ariaLabel="{{ t('expireAtLabel', { timezone: orgData?.getTimezone() }) }}"
            [formControl]="expireAt"
            [ngClass]="{ 'ng-invalid': expireAt?.invalid }"
            placeholder="{{ t('expireAtLabel') }}"
          />
          <p id="expireAt-help">{{ t('expireAtHelp', { timezone: orgData?.getTimezone() }) }}</p>
          <p *ngIf="expireAt.hasError('isAfter')" class="p-error">{{ t('expireTimeErrorIsAfter') }}</p>
          <p *ngIf="expireAt.hasError('required')" class="p-error">{{ t('expireTimeErrorRequired') }}</p>
        </span>
      </div>
    </div>
  </form>
  <app-progress-spinner *ngIf="orgData === undefined"></app-progress-spinner>
</ng-container>
